import React, { useCallback, useEffect } from "react";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { useFetchRetailerInfo } from "web/react/hooks/use-fetch-retailer-info";
import { useInStockProductPageContext } from "web/react/pages/product/in-stock/in-stock-product-page/in-stock-product-page.context";
import { gettext } from "web/script/modules/django-i18n";
import { ProductBuyOptionsSerializer } from "web/types/serializers";
import * as styles from "./view-seller-details.css";

export interface ViewSellerDetailsProps {
    prefetch?: boolean;
    buyOption: ProductBuyOptionsSerializer;
    onClick: () => void;
}

export function ViewSellerDetails({
    prefetch = false,
    buyOption,
    onClick,
}: ViewSellerDetailsProps): React.ReactElement {
    const { openRetailerInfoModal } = useInStockProductPageContext();
    const { fetchRetailerInfo } = useFetchRetailerInfo();

    const handleOpenRetailerModal = useCallback(async (): Promise<void> => {
        openRetailerInfoModal();
        onClick();
        await fetchRetailerInfo(buyOption.retailer_slug);
    }, [openRetailerInfoModal, buyOption.retailer_slug, fetchRetailerInfo, onClick]);

    useEffect(() => {
        if (prefetch) {
            fetchRetailerInfo(buyOption.retailer_slug);
        }
    }, [buyOption, prefetch, fetchRetailerInfo]);

    return (
        <View
            dataTestId="buy-option-card-view-seller-details"
            width="full"
            className={styles.viewSellerDetailsButton}
            onClick={handleOpenRetailerModal}
        >
            <Text textStyle="body-xs" underline>
                {gettext("product.view_seller_details")}
            </Text>
        </View>
    );
}
